var client_width = $(window).width() + 17;
setTimeout(function () {
  ut2();
}, 500);
function ut2() {
  var i = $(window).width();
  // module2动画 轮播图
  var animation_img = $("#UT2_2025 .module2 .swiper1_box .module2_bg");

  // module3
  var module3_order_1 = $("#UT2_2025 .module3 .content .img_box .img_zz");
  var module3_order_2 = $("#UT2_2025 .module3 .content .content_solgan");
  var module3_sticky = $("#UT2_2025 .module3 .content_sticky");

  // module8
  var module8_order_1 = $("#UT2_2025 .module8 .content .img_box .img_zz");
  var module8_order_2 = $("#UT2_2025 .module8 .content .content_solgan");
  var module8_sticky = $("#UT2_2025 .module8 .content_sticky");

  // module12
  var module12_order_1 = $("#UT2_2025 .module12 .content .img_box .img_zz");
  var module12_order_2 = $("#UT2_2025 .module12 .content .content_solgan");
  var module12_sticky = $("#UT2_2025 .module12 .content_sticky");

  // module18
  var module18_order_1 = $("#UT2_2025 .module18 .content .img_box .img_zz");
  var module18_order_2 = $("#UT2_2025 .module18 .content .content_solgan");
  var module18_sticky = $("#UT2_2025 .module18 .content_sticky");

  // module9
  var animation_9 = $("#UT2_2025 .module9 .animation_9");
  var animation_9_img = $("#UT2_2025 .module9 .animation_9 img");
  var animation_9_sticky = $("#UT2_2025 .module9 .animation_9_sticky");
  if (i > 1080) {
    // module2
    var swiper_1 = new Swiper("#swiper1", {
      speed: 500,
      breakpoints: {
        1080: {
          spaceBetween: "2.25%",
        },
      },
    });

    ScrollTrigger.create({
      trigger: animation_img,
      start: "top 10%",
      end: "bottom 80%",
      scrub: true,
      animation: gsap
        .timeline()
        .fromTo(animation_img, { opacity: "0" }, { opacity: "1" }),
    });

    ScrollTrigger.create({
      trigger: ".swiper1_box", // 触发器的目标元素
      start: "top top", // 触发器开始的位置
      end: "+=200%", // 触发器结束的位置（根据页面滚动距离）
      pin: true, // 固定 Swiper 容器
      onUpdate: (self) => {
        // 根据滚动进度控制 Swiper
        const progress = self.progress; // 获取滚动进度（0 到 1）
        const slideIndex = Math.floor(progress * swiper_1.slides.length); // 计算对应的 Swiper 幻灯片索引
        swiper_1.slideTo(slideIndex); // 切换到对应的幻灯片
      },
    });

    // module3
    var ut2_3 = gsap.timeline();
    ut2_3
      .to(module3_order_1, 0, {
        opacity: 0,
      })
      .to(module3_order_1, 2, {
        opacity: 0.3,
      });
    ut2_3
      .to(module3_order_2, 0, {
        display: "none",
      })
      .to(module3_order_2, 1, {
        display: "block",
      });
    ScrollTrigger.create({
      animation: ut2_3,
      trigger: module3_sticky,
      scrub: !0,
      start: "top 100%",
      end: "bottom 120%",
    });

    // module8
    var ut2_8 = gsap.timeline();
    ut2_8
      .to(module8_order_1, 0, {
        opacity: 0,
      })
      .to(module8_order_1, 2, {
        opacity: 0.3,
      });
    ut2_8
      .to(module8_order_2, 0, {
        display: "none",
      })
      .to(module8_order_2, 1, {
        display: "block",
      });
    ScrollTrigger.create({
      animation: ut2_8,
      trigger: module8_sticky,
      scrub: !0,
      start: "top 100%",
      end: "bottom 120%",
    });

    // module12
    var ut2_12 = gsap.timeline();
    ut2_12
      .to(module12_order_1, 0, {
        opacity: 0,
      })
      .to(module12_order_1, 2, {
        opacity: 0.3,
      });
    ut2_12
      .to(module12_order_2, 0, {
        display: "none",
      })
      .to(module12_order_2, 1, {
        display: "block",
      });
    ScrollTrigger.create({
      animation: ut2_12,
      trigger: module12_sticky,
      scrub: !0,
      start: "top 100%",
      end: "bottom 120%",
    });

    // module18
    var ut2_18 = gsap.timeline();
    ut2_18
      .to(module18_order_1, 0, {
        opacity: 0,
      })
      .to(module18_order_1, 2, {
        opacity: 0.3,
      });
    ut2_18
      .to(module18_order_2, 0, {
        display: "none",
      })
      .to(module18_order_2, 1, {
        display: "block",
      });
    ScrollTrigger.create({
      animation: ut2_18,
      trigger: module18_sticky,
      scrub: !0,
      start: "top 100%",
      end: "bottom 120%",
    });

    // module9
    // ScrollTrigger.create({
    //     trigger: animation_9_sticky,
    //     start: 'top bottom',
    //     end: "bottom bottom",
    //     scrub: true,
    //     animation:
    //     gsap.timeline()
    //         .fromTo(animation_9_img, {width: '130%',top: '-12%'}, {width: '55%',top: '80px'})
    //         .fromTo(animation_9, {height: '100vh'}, {height: '40vw'})
    // });

    // module15
    var animation_15 = $("#UT2_2025 .module15 > img");
    ScrollTrigger.create({
      trigger: animation_15,
      start: "top bottom",
      end: "bottom bottom",
      scrub: true,
      animation: gsap
        .timeline()
        .fromTo(animation_15, { width: "100%" }, { width: "74.21875%" }),
    });

    // module10滑块
    let img = document.querySelector("#img_cover");
    let btn = document.querySelector("#btn_icon");
    let nav = document.querySelector(".animation_10");
    btn.onmousedown = function (e) {
      let clientx = e.clientX; // 点击获取鼠标初始X坐标
      nav.onmousemove = function () {
        let e = arguments[0] || window.event;
        let X = e.clientX; // 移动时获取鼠标移动时的X坐标
        let imgW = parseInt(getComputedStyle(img, null).width);
        img.style.width = `${imgW + X - clientx}px`; // 图片宽度 = 移动时的X坐标 - 点击时的初始坐标 也就是 图片宽度 + 鼠标X坐标的偏移量
        clientx = X; // 将最新的位置的X坐标 赋值给 点击初始坐标 也就是 更新 X坐标初始值
      };
    };
    document.onmouseup = function () {
      nav.onmousemove = null;
    };
  } else {
    // module3
    ScrollTrigger.create({
      trigger: module3_order_1,
      start: "top center",
      end: "bottom bottom",
      scrub: true,
      animation: gsap
        .timeline()
        .fromTo(module3_order_1, { opacity: "0" }, { opacity: "0.3" })
        .fromTo(module3_order_2, { display: "none" }, { display: "block" }),
    });

    // module8
    ScrollTrigger.create({
      trigger: module8_order_1,
      start: "top center",
      end: "bottom bottom",
      scrub: true,
      animation: gsap
        .timeline()
        .fromTo(module8_order_1, { opacity: "0" }, { opacity: "0.3" })
        .fromTo(module8_order_2, { display: "none" }, { display: "block" }),
    });

    // module12
    ScrollTrigger.create({
      trigger: module12_order_1,
      start: "top center",
      end: "bottom bottom",
      scrub: true,
      animation: gsap
        .timeline()
        .fromTo(module12_order_1, { opacity: "0" }, { opacity: "0.3" })
        .fromTo(module12_order_2, { display: "none" }, { display: "block" }),
    });

    // module18
    ScrollTrigger.create({
      trigger: module18_order_1,
      start: "top center",
      end: "bottom bottom",
      scrub: true,
      animation: gsap
        .timeline()
        .fromTo(module18_order_1, { opacity: "0" }, { opacity: "0.3" })
        .fromTo(module18_order_2, { display: "none" }, { display: "block" }),
    });
  }
}

$(window).scroll(function () {
  var module2_top =
    $("#UT2_2025 .module7 .animation_7 .content1 .line_box .line1").offset()
      .top <=
    $(window).height() + $(window).scrollTop();
  if (!module2_top) {
    $("#UT2_2025 .module7 .animation_7").removeClass("active");
  } else {
    $("#UT2_2025 .module7 .animation_7").addClass("active");
  }
});

// module22轮播图
var swiper_2 = new Swiper("#swiper2", {
  speed: 1000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  direction: "vertical",
  pagination: {
    el: "#swiper2 .swiper-pagination",
    type: "progressbar",
  },
  on: {
    slideChangeTransitionEnd: function () {
      var currentIndex = this.activeIndex;
      if (currentIndex == 0) {
        $(
          "#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet_1"
        ).addClass("active");
        $(
          "#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet_2"
        ).removeClass("active");
        $(
          "#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet_3"
        ).removeClass("active");
      }
      if (currentIndex == 1) {
        $(
          "#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet_1"
        ).removeClass("active");
        $(
          "#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet_2"
        ).addClass("active");
        $(
          "#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet_3"
        ).removeClass("active");
      }
      if (currentIndex == 2) {
        $(
          "#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet_1"
        ).removeClass("active");
        $(
          "#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet_2"
        ).removeClass("active");
        $(
          "#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet_3"
        ).addClass("active");
      }
    },
  },
});
$("#UT2_2025 .module22 .swiper_box .pagination_box .pagination_bullet").click(
  function () {
    var this_index_1 = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    swiper_2.slideTo(this_index_1, 1000, false);
  }
);
